import React, { useState } from 'react';
import './products.css';
import Common_Banner from '../common-components/common_banner/Common_Banner';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Product_card from '../common-components/common-card/product-card/Product_card';
import All_products from '../common-components/all-products/All_products';
import Breadcrumbdata from '../common-components/breadcrumbs/Breadcrumbdata';
import Heading_title from '../common-components/common-title/heading-title/Heading_title';

const Products = () => {
    const breadcrumbs = [
        { label: "HOME", link: "/", active: false },
        { label: "PRODUCTS", link: "/all-products", active: true },
    ];



    // const categories = [
    //     { key: "one", label: "1 New Old Rupees Counter & Sorting Machine (Cassida CS-225)" },
    //     { key: "two", label: "2 New Old Rupees Counter & Sorting Machine (Cassida CS-225)" },
    //     { key: "five", label: "5 New Old Rupees Counter & Sorting Machine (Cassida CS-225)" },
    //     { key: "ten", label: "10 New Old Rupees Counter & Sorting Machine (Cassida CS-225)" },
    //     { key: "twenty", label: "20 New Old Rupees Counter & Sorting Machine (Cassida CS-225)" },
    //     { key: "foreign", label: "Foreign Currency Counter & Sorting Machine (Cassida CS-225)" },
    // ];

    // const [activeCategory, setActiveCategory] = useState(categories[0].key);
    // const [searchTerm, setSearchTerm] = useState("");

    // const getProductsByCategory = (categoryKey) => {
    //     if (categoryKey === "all") return All_products;
    //     return All_products.filter(product => product.category === categoryKey);
    // };

    // const handleSearchChange = (e) => {
    //     setSearchTerm(e.target.value.toLowerCase());
    // };

    // const handleSearchSubmit = (e) => {
    //     e.preventDefault();
    //     console.log("Search submitted for:", searchTerm);
    // };

    return (
        <div className='container-fluid p-0'>
            <Common_Banner imgSrc="/assets/images/banners/product-banner.png" />

            <div className='container-lg'>
                <Breadcrumbdata data={breadcrumbs} />
                <div className='product_tab_sec'>
                    <Tab.Container
                        // id="left-tabs-example"
                        // activeKey={activeCategory}
                        // onSelect={(k) => {
                        //     setActiveCategory(k);
                        //     setSearchTerm("");
                        // }}
                    >
                        <div className='row'>

                            <div className='col-lg-3 col-md-4'>
                                <div className='tabbtnsec'>
                                    {/* <div className='leftbox'>
                                        <div className='titlediv'>
                                            <h4 className='cath4'>CATEGORIES</h4>
                                        </div>
                                        <Nav variant="pills" className="flex-column">
                                            {categories.map((cat) => (
                                                <Nav.Item key={cat.key}>
                                                    <Nav.Link eventKey={cat.key}>{cat.label}</Nav.Link>
                                                </Nav.Item>
                                            ))}
                                        </Nav>
                                    </div> */}


                                    <div className='leftbox contleftbox'>
                                        <div className='titlediv'>
                                            <h4 className='cath4'>CONTACT US</h4>
                                        </div>

                                        <div className='contsec'>
                                            <div className='flexdiv'>
                                                <div className='icondiv bd1'>
                                                    <i className="bi bi-telephone-fill icon"></i>
                                                </div>
                                                <div className='textdiv'>
                                                    <p className='numb'>+8766701045 / 7721091787</p>
                                                </div>
                                            </div>
                                            <div className='flexdiv'>
                                                <div className='icondiv'>
                                                    <i className="bi bi-envelope-fill icon"></i>
                                                </div>
                                                <div className='textdiv'>
                                                    <p className='numb'>scroma1001@gmail.com</p>
                                                </div>
                                            </div>
                                            <div className='flexdiv'>
                                                <div className='icondiv bd2'>
                                                    <i className="bi bi-geo-alt-fill icon"></i>
                                                </div>
                                                <div className='textdiv'>
                                                    <p className='numb'>Flat No.102, Rajgad Heights, Phaltan Road, Kasba, Baramati-413102</p>
                                                </div>
                                            </div>
                                        </div>




                                        {/* <p><i className="bi bi-envelope-fill me-2"></i>scroma1001@gmail.com</p>
                                        <p><i className="bi bi-geo-alt-fill me-2"></i>Flat No.102, Rajgad Heights, Phaltan Road, Kasba, Baramati-413102</p> */}

                                    </div>
                                </div>
                            </div>

                            {/* Right Content */}
                            <div className='col-lg-9 col-md-8'>

                                <Heading_title title={'All Products'} />

                                <div className='row'>
                                     {All_products.map((product, index) => (
                                    <div className='col-md-4 mb-4'>
                                        <Product_card
                                            key={product?.id}
                                            image={product?.image}
                                            modelno={product?.title}
                                            product_name={product?.subtitle}
                                            link={`/products/${product?.id}`}
                                        />
                                    </div>
                                     ))}
                                </div>


                                {/* <div className='category-header d-flex justify-content-between align-items-center mb-3'>
                                    <h5 className='mb-0'>
                                        {categories.find(cat => cat.key === activeCategory)?.label}
                                    </h5>

                                    <form className="search-container" onSubmit={handleSearchSubmit}>
                                        <input
                                            type="text"
                                            className='form-control'
                                            placeholder='Enter Keywords'
                                            value={searchTerm}
                                            onChange={handleSearchChange}
                                        />
                                        <button type="submit" className="search-button" aria-label="Search">
                                            <i className="bi bi-search"></i>
                                        </button>
                                    </form>
                                </div> */}

                                {/* <Tab.Content>
                                    {categories.map((cat) => {
                                        const filteredProducts = getProductsByCategory(cat.key)
                                            .filter(product =>
                                                product.title.toLowerCase().includes(searchTerm) ||
                                                product.subtitle.toLowerCase().includes(searchTerm)
                                            );

                                        return (
                                            <Tab.Pane eventKey={cat.key} key={cat.key}>
                                                <div className='tabdata'>
                                                    <div className='row'>
                                                        {filteredProducts.length > 0 ? (
                                                            filteredProducts.map((product) => (
                                                                <div className='col-lg-4 col-md-4 col-sm-6 col-6 mb-4 p-1' key={product.id}>
                                                                    <Product_card
                                                                        image={product.image}
                                                                        modelno={product.title}
                                                                        product_name={product.subtitle}
                                                                        link={`/products/${product.id}`}
                                                                    />
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="col-12">
                                                                <p>No products found in this category.</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        );
                                    })}
                                </Tab.Content> */}


                            </div>
                        </div>
                    </Tab.Container>
                </div>
            </div>
        </div>
    );
};

export default Products;
